import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

export interface DisplayFieldConfig {
  key: string;                 // actual field to display
  label?: string;              // UI label
  type?: 'text' | 'date' | 'boolean' | 'icon' | 'image';
  showLabel?: boolean;
  iconField?: string;          // (optional) field with icon name
  colorField?: string;         // (optional) field with icon color
  backgroundColorField?: string; // (optional) background color
  isNested?: boolean;          // flag if key uses dot notation
}

export interface DisplayDetailConfig {
  fields: DisplayFieldConfig[];
  columns?: 1 | 2 | 3 | 4; // 1-4 columns, default 2
  showLabels?: boolean; // default true
}

@Component({
    selector: 'app-display-detail',
    templateUrl: 'app-display-detail.component.html',
    standalone: false
})
export class AppDisplayDetailComponent implements OnInit, OnChanges, OnDestroy {

  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized

  @Input() data: any = {};
  @Input() config!: DisplayDetailConfig;

  getColumnClass(): string {
    const cols = this.config.columns || 2;

    switch (cols) {
      case 1:
        return 'col-12';
      case 2:
        return 'col-12 md:col-6';
      case 3:
        return 'col-12 md:col-4';
      case 4:
        return 'col-12 md:col-3';
      default:
        return 'col-12 md:col-6';
    }
  }

  getLabel(field: DisplayFieldConfig): string {
    return field.label ?? field.key;
  }

  getIconClass(field: DisplayFieldConfig): string {
    const icon = this.getValue(field.iconField || field.key);
    if (!icon) return 'pi-question-circle';

    // If FontAwesome class provided (fa-light fa-user), return raw
    if (icon.includes('fa')) return icon;

    // Fallback to PrimeNG icon class
    return 'pi-' + icon;
  }

  getColor(field: DisplayFieldConfig): string | null {
    return this.getValue(field.colorField || '');
  }

  getBackgroundColor(field: DisplayFieldConfig): string | null {
    return this.getValue(field.backgroundColorField || '');
  }

// Supports dot notation: addressDto.addressTypeDtoName
  getValue(path: string): any {
    if (!path) return null;
    return path.split('.').reduce((obj, part) => obj?.[part], this.data);
  }

  constructor() {
  }


  ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }


  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
